import { render } from "./certified-icon.vue?vue&type=template&id=2c34ca80"
import script from "./certified-icon.vue?vue&type=script&lang=js"
export * from "./certified-icon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__